export default __webpack_public_path__ + "static/media/icon-monTableau-select.ab2e39a2.svg";